import { IgetEmpreendimentoDropDownUseCase } from "../../../presentation/useCases/read/get_empreendimento_drop_down_use_case";
import { DropDown } from "../../models/dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * getEmpreendimentoDropDownUseCase
 */

export class getEmpreendimentoDropDownUseCase implements IgetEmpreendimentoDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getEmpreendimentoDropDown(idObra?: number | null): Promise<DropDown[]> {
    return await this.repository.getEmpreendimentoDropDown(idObra);
  }
}
